const PAYMENT_ACTION = {
    CASH_BALANCE_REFUND: 'CASH_BALANCE_REFUND',
};

const isCashBalanceRefund = paymentAction => PAYMENT_ACTION.CASH_BALANCE_REFUND === paymentAction;

export { PAYMENT_ACTION, isCashBalanceRefund };
